// Copyright (c) 2016 Deere & Company

import UpdateMachineStatusHistory from '@deere/cps-it.warranty-model-factory/lib/update-machine-status-history';
import t from 'tcomb';

const Report = t.list(UpdateMachineStatusHistory, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/state/report.js